import { FillKeyframe, ShakeKeyframe } from './EdAnimatedIcon.animations';
import { AnimationList } from './EdAnimatedIcon.types';
export const Animations: AnimationList = {
	shake: ShakeKeyframe,
	'fill-left': FillKeyframe,
};
